import { constants } from '@/config';

const App = () => import('@/app/facebook/App.vue');
const BoardsIndex = () => import('@/app/boards/pages/BoardsIndex.vue');
const Overview = () => import('@/components/core/analytics/ChannelOverviewPage.vue');
const AnalyticsYourPostsPage = () =>
  import('@/components/core/analytics/AnalyticsYourPostsPage.vue');

const PAGE_LEVEL_TOP = `Facebook`;

export default {
  path: 'facebook',
  component: App,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      name: 'facebook',
      path: '',
      redirect: { name: 'facebook.overview' },
    },
    {
      name: 'facebook.dashboard',
      path: 'dashboard',
      component: Overview,
      redirect: { name: 'facebook.overview' },
    },
    {
      name: 'facebook.dashboard.report',
      path: 'dashboard/report',
      component: Overview,
      meta: {
        report: true,
      },
      redirect: { name: 'facebook.overview.report' },
    },
    {
      name: 'facebook.overview',
      path: 'overview',
      component: Overview,
      props: { channel: constants.FACEBOOK, key: constants.FACEBOOK },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview`,
      },
    },
    {
      name: 'facebook.overview.report',
      path: 'overview/report',
      component: Overview,
      props: { channel: constants.FACEBOOK, key: constants.FACEBOOK },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Overview Report`,
        report: true,
      },
    },
    {
      name: 'facebook.yourPosts',
      path: 'your-posts',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.FACEBOOK,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts`,
      },
    },
    {
      name: 'facebook.yourPosts.report',
      path: 'your-posts/report',
      component: AnalyticsYourPostsPage,
      props: {
        channel: constants.FACEBOOK,
      },
      meta: {
        analytics: `${PAGE_LEVEL_TOP} - Your Posts Report`,
        report: true,
      },
    },
    {
      path: 'boards',
      children: [
        {
          name: 'facebook.galleries',
          path: '',
          component: BoardsIndex,
          props: {
            galleryType: constants.FACEBOOK,
          },
          meta: {
            analytics: `${PAGE_LEVEL_TOP} - Boards`,
          },
        },
      ],
    },
  ],
};
